<p-toast></p-toast>

<div class="formgrid grid">
    <div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-4">
        <label for="inventoryStatus">Catégorie<span class="requis">*</span></label>
        <p-dropdown [(ngModel)]="item.categorie" inputId="categorie" [options]="listeCategories"
            [loading]="!listeCategories" optionLabel="nom" placeholder="Sélectionnez..." appendTo="body"
            [disabled]="indLocation">
            <ng-template let-option pTemplate="item">
                <span>{{option.nom}}</span>
            </ng-template>
        </p-dropdown>
        <small class="p-error" *ngIf="submitted && !item.categorie">La catégorie est obligatoire.</small>
    </div>
    <div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-4">
        <label for="inventoryStatus">Sous-catégorie</label>
        <p-dropdown [options]="listeSousCategoriesFiltrees" [(ngModel)]="item.sousCategorie" optionLabel="nom"
            [loading]="!listeSousCategoriesFiltrees" [disabled]="!item.categorie"
            (onChange)="surChangementSousCategorie($event)" [showClear]="true" appendTo="body" filter="true"
            filterBy="nom" placeholder="Sélectionnez une sous-catégorie...">
            <ng-template pTemplate="selectedItem">
                <div *ngIf="item.sousCategorie">
                    <div>{{item.sousCategorie.nom}}</div>
                </div>
            </ng-template>
            <ng-template let-sousCategorie pTemplate="item">
                <div>
                    <div>{{sousCategorie.nom}}</div>
                </div>
            </ng-template>
        </p-dropdown>
    </div>
    <div *ngIf="item.categorie && item.categorie.estUnique"
        class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-4">
        <label for="compagnie">Compagnie<span class="requis">*</span></label>
        <p-dropdown [options]="listeCompagnies" [(ngModel)]="item.compagnie" optionLabel="nom" [showClear]="true"
            [loading]="!listeCompagnies" appendTo="body" filter="true" filterBy="nom"
            placeholder="Sélectionnez une compagnie...">
            <ng-template pTemplate="selectedItem">
                <app-compagnie-label *ngIf="item.compagnie" [compagnie]="item.compagnie"></app-compagnie-label>
            </ng-template>
            <ng-template let-compagnie pTemplate="item">
                <app-compagnie-label [compagnie]="compagnie"></app-compagnie-label>
            </ng-template>
        </p-dropdown>
        <small class="p-error" *ngIf="submitted && !item.compagnie">La compagnies est obligatoire.</small>
    </div>
</div>
<div class="formgrid grid" *ngIf="item.categorie">
    <div class="flex flex-column gap-2 my-2 col-10 md:col-4 lg:col-3" *ngIf="item.categorie.estUnique">
        <label for="noSIHC">No SIHC<span class="requis">*</span></label>
        <p-inputGroup>
            <input #champNumero type="text" pInputText id="noSIHC" [(ngModel)]="item.numero" autocomplete="off"
                autofocus />
            <button pButton pRipple icon="pi pi-search" label="Prochain" class="p-button-primary"
                [loading]="loadingProchainNumero" (click)="obtenirProchainNumero()"
                [disabled]="isProchainDisabled"></button>
        </p-inputGroup>
        <small class="p-error" *ngIf="submitted && !item.numero">Le numéro SIHC est
            obligatoire.</small>
    </div>
    <div class="flex flex-column gap-2 my-2 col-12 md:col-8 lg:col-9">
        <label for="description">Description<span class="requis">*</span></label>
        <!--  <input #descriptionitem type="text" pInputText id="description"
                    [(ngModel)]="item.description" autocomplete="off" /> -->
        <p-autoComplete #champDescription appendTo="body" [(ngModel)]="item.description"
            [suggestions]="suggestionDescription" (completeMethod)="rechercherDescription($event)"
            [loading]="!suggestionDescription">
        </p-autoComplete>
        <small class="p-error" *ngIf="submitted && !item.description">La description
            est
            obligatoire.</small>
    </div>
</div>
<div class="formgrid grid" *ngIf="item.categorie">
    <div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-4">
        <label for="marque">Marque</label>
        <!-- <input type="text" pInputText id="marque" [(ngModel)]="item.marque" autocomplete="off"
                    autofocus /> -->
        <p-autoComplete appendTo="body" [(ngModel)]="item.marque" [suggestions]="suggestionMarque"
            (completeMethod)="rechercherMarque($event)"></p-autoComplete>
    </div>
    <div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-4">
        <label for="modele">Modèle</label>
        <input type="text" pInputText id="modele" [(ngModel)]="item.modele" autocomplete="off" autofocus />
    </div>
    <div *ngIf="item.categorie.estFacturable" class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-4">
        <label for="noCtrl">Numéro CTRL</label>
        <input type="text" pInputText id="noCtrl" [(ngModel)]="item.noCtrl" autocomplete="off" autofocus />
    </div>

</div>
<div class="formgrid grid" *ngIf="item.categorie">
    <div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-4" *ngIf="item.categorie.estUnique">

        <label for="lastname">Emplacement de départ<span class="requis">*</span></label>
        <p-dropdown [options]="emplacements" [(ngModel)]="item.emplacement" optionLabel="nom" appendTo="body"
            [loading]="!emplacements" [showClear]="true" filter="true" filterBy="code,nom"
            placeholder="Sélectionner un emplacement...">
            <ng-template pTemplate="selectedItem">
                <div *ngIf="item.emplacement">
                    <div>{{item.emplacement | nomEmplacement}}</div>
                </div>
            </ng-template>
            <ng-template let-emplacement pTemplate="item">
                <div>
                    <div>{{emplacement | nomEmplacement}}</div>
                </div>
            </ng-template>
        </p-dropdown>
        <small class="p-error" *ngIf="submitted && !item.emplacement">L'emplacement de départ
            est
            obligatoire.</small>
    </div>
    <div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-4">

        <label for="lastname">Localisation entrepot</label>
        <p-dropdown [options]="listeLocalisations" [(ngModel)]="item.localisation" optionLabel="nom"
            [loading]="!listeLocalisations" appendTo="body" [showClear]="true" filter="true" filterBy="code,nom"
            placeholder="Sélectionner une localisation...">
            <ng-template pTemplate="selectedItem">
                <div *ngIf="item.localisation">
                    <div>{{item.localisation.nom}}</div>
                </div>
            </ng-template>
            <ng-template let-loc pTemplate="item">
                <div>
                    <div>{{loc.nom}}</div>
                </div>
            </ng-template>
        </p-dropdown>
    </div>
    <div *ngIf="item.categorie.categorieId === 3" class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-4">
        <label for="lastname">Est-ce un produit dangereux<span class="requis">*</span></label>
        <p-selectButton [options]="produitDangereuxOptions" [(ngModel)]="item.produitDangereux" optionLabel="label"
            optionValue="value" />
        <small class="p-error"
            *ngIf="submitted && (item.produitDangereux === null || item.produitDangereux === undefined)">Veuiller
            sélectionner si le produit est dangereux.</small>
    </div>
    <div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-4" *ngIf="item.categorie.estFacturable">

        <label for="lastname">Type de facturation</label>
        <p-dropdown [options]="listeTypesFacturation" [(ngModel)]="item.typeFacturation" optionLabel="nom"
            [loading]="!listeTypesFacturation" appendTo="body" [showClear]="true" filter="true" filterBy="code,nom"
            placeholder="Sélectionner un type de facturation...">
            <ng-template pTemplate="selectedItem">
                <div *ngIf="item.typeFacturation">
                    <div>{{item.typeFacturation.nom}}</div>
                </div>
            </ng-template>
            <ng-template let-typeFacturation pTemplate="item">
                <div>
                    <div>{{typeFacturation.nom}}</div>
                </div>
            </ng-template>
        </p-dropdown>
    </div>
</div>

<div *ngIf="ref" class="flex justify-content-end gap-2">
    <p-button label="Annuler" text (click)="onClose()" />
    <p-button label="Valider" (click)="onSubmit()" />
</div>